module.exports = __webpack_public_path__ + "static/media/avatar.f9bb0f33.png";